import apiClient from './apiClient';

export interface SessionData {
  email: string;
  password: string;
  instruction: string;
  endDate: number;
  proxyIP: string;
  proxyPort: string;
  proxyUsername?: string;
  proxyPassword?: string;
}

export async function encryptSessionData(data: SessionData, arbitraryKey: string): Promise<string> {
  const response = await apiClient.post('/exileguard/encrypt', {
    data,
    arbitraryKey,
  });

  return response.data.key;
}

export async function decryptSessionData(encryptedData: string, arbitraryKey: string): Promise<SessionData> {
  const response = await apiClient.post('/exileguard/decrypt', {
    encryptedData,
    arbitraryKey,
  });

  return response.data.data;
}
